export default __webpack_public_path__ + "static/media/ST4_SLEEK_MOIST_550_L.eae6dadd.png";